import React from 'react';

import { Box, Center } from '@chakra-ui/react';

import BasicCarousel from '../../components/BasicCarousel';
import SolutionTypePartnersCard from './SolutionTypePartnersCard';
import { PortfolioPartnerData, SolutionTypeData } from '../../types/interfaces';

const SolutionTypePartnersCardCarousel = (props: {
  solutionTypesData: SolutionTypeData[];
  partnersData: PortfolioPartnerData[];
}) => {
  return (
    <BasicCarousel>
      {props.solutionTypesData.map((solutionTypeData) => (
        <Center h={650} key={solutionTypeData.name}>
          <Box h={600} maxW="500px" marginX={3}>
            <SolutionTypePartnersCard
              solutionTypeData={solutionTypeData}
              partnersData={props.partnersData.filter(
                (partner: PortfolioPartnerData) =>
                  partner.solutionType === solutionTypeData.id &&
                  partner.isActive,
              )}
            />
          </Box>
        </Center>
      ))}
    </BasicCarousel>
  );
};

export default SolutionTypePartnersCardCarousel;
